import { ref } from 'vue'

export default function useFilters(filters) {
    const initial = { ...filters.value }
    const filtersLocal = ref({ ...filters.value })

    function applyFilters() {
        const final = { ...filters.value, ...filtersLocal.value }
        filters.value = final
    }

    function resetFilters() {
        Object.assign(filtersLocal.value, initial)
        filters.value = { ...initial }
    }

    return { filtersLocal, applyFilters, resetFilters }
}